const currentDomain = window.location.hostname;
const isDev = currentDomain === 'dev-app.acemoney.in' || currentDomain === 'localhost';

const BASE_URL = isDev ? 'https://rag-dev.acepe.co.in/dev/' : 'https://rag.acepe.co.in/';

export const RAG_API_ENDPOINTS = {
    history: `${BASE_URL}api/support/history`,
    message: `${BASE_URL}api/support/message`,
    getTickets: (agentCode) => `${BASE_URL}users/${agentCode}/tickets`,
    getTicketMessages: (ticketNo) => `${BASE_URL}tickets/${ticketNo}/messages`,
    uploadAttachment: `${BASE_URL}attachments/upload`,
    saveTicket: `${BASE_URL}api/tickets`
};
